import React, { useEffect, useState } from "react";
import Sidebar from "../commonAdmin/Sidebar";
import Header from "../commonAdmin/Header";
import Footer from "../commonAdmin/Footer";
import {
  Row,
  Col,
  Form,
  Table,
  InputGroup,
} from "react-bootstrap";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";
import delivaApiService from "../../../common/services/apiService";
import { formatStatusMessage, getStatusBackgroundColor, getStatusClassName, toTitleCase } from "../../../common/helpers/Utils";
import WarningBox from "../../../common/helpers/WarningBox";
import Loader from "../../common/Loader";
import reject from '../../../assets/images/warning.png';
import LocationSearchInput from "./LocationSearchInput";

import { getGeocode, getLatLng } from "use-places-autocomplete";

const RouteList = (props) => {
  const [selectedRoute, setSelectedRoute] = useState("");

  const history = useHistory();
  // const [showWarning, setShowWarning] = useState(true);

  const [address, setAddress] = useState("");
  const [coordinates, setCoordinates] = useState({ lat: '', lng: '' });

  const [sourceLocation, setSourceLocation] = useState("");
  const [clearSource, setClearSource] = useState(false);

  const [destinationLocation, setDestinationLocation] = useState("");
  const [clearDestination, setClearDestination] = useState(false);

  const [routes, setRoutes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageno, setPageno] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [pageArray, setPageArray] = useState([]);
  const [records, setRecords] = useState(10);
  const [sortBy, setSortBy] = useState("deliveryType"); // default sort by deliveryType
  const [sortOrder, setSortOrder] = useState("asc"); // default order ascending
  const [totalRecords, setTotalRecords] = useState("");
  const [ishover, setIshover] = useState(false);
  const handleSelectChange = (e) => {
    setSelectedRoute(e.target.value);
  };

  console.log('Lat', coordinates.lat, 'Lng', coordinates.lng)
  // ,sourceLocation,destinationLocation,
  useEffect(() => {
    getRoutes(sourceLocation, destinationLocation);
  }, [selectedRoute, pageno, records, sortBy, sortOrder]);

  // get user current lat/lng
  const lat = localStorage.getItem("user_lat");
  const lng = localStorage.getItem("user_lng");
  const userId = localStorage.getItem("id");

  console.log('user id', userId)

  const getRoutes = async (sourceLocation, destinationLocation) => {
    setLoading(true)
    const payload = {
      deliveryType: selectedRoute || 'LOCAL',
      source: sourceLocation,
      destination: destinationLocation,
      userId: userId,
      page: pageno,
      size: records,
      orderBy: sortBy,
      orderType: sortOrder,
      currentLatitude: lat || '',
      currentLongitude: lng || ''
    };
    delivaApiService("getRouteListing", payload)
      .then((response) => {
        if (response?.data?.status === 200) {
          const totalRecords = response?.data?.totalRecords;
          const totalPages = Math.ceil(totalRecords / records);

          setRoutes(response?.data?.resourceData?.routeList);
          setTotalPage(totalPages);
          setPageArray(generatePageArray(totalPages, pageno));
          setLoading(false);
          setTotalRecords(totalRecords);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const generatePageArray = (totalPages, currentPage) => {
    let startPage, endPage;

    if (totalPages <= 5) {
      startPage = 1;
      endPage = totalPages;
    } else {
      if (currentPage <= 3) {
        startPage = 1;
        endPage = 5;
      } else if (currentPage + 1 >= totalPages) {
        startPage = totalPages - 4;
        endPage = totalPages;
      } else {
        startPage = currentPage - 2;
        endPage = currentPage + 2;
      }
    }

    const pageArray = [];
    for (let i = startPage; i <= endPage; i++) {
      pageArray.push(i);
    }

    return pageArray;
  };

  const handleSortChange = (column) => {
    if (sortBy === column) {
      setSortOrder(sortOrder === "ASC" ? "DESC" : "ASC");
      console.log('sorting.....', sortOrder)
    } else {
      setSortBy(column);
      setSortOrder("ASC");
    }
  };

  const onChangePage = (page) => {
    setPageno(page);
    setPageArray(generatePageArray(totalPage, page));
  };

  const onChangeItemPerPage = (e) => {
    const rawValue = e.target.value;

    if (rawValue === "") {
      setRecords("");
      return;
    }
    if (rawValue === "0") {
      return;
    }
    const numberRegex = /^[1-9][0-9]*$/;
    if (numberRegex.test(rawValue)) {
      setRecords(rawValue);
      setPageno(1);
    }
  };

  const handleSwitchChange = (routeId, isActive) => {
    const payload = {
      routeId: routeId,
      active: isActive,
      userId: userId,
    };

    delivaApiService("activeInactiveStatus", payload)
      .then((response) => {
        if (response?.data?.status === 200) {
          getRoutes(sourceLocation, destinationLocation);
        }
      })
      .catch((error) => {
        console.error("Failed to update status:", error);
      });
  };
  const handleViewCLick = (route) => {
    history.push("/route-details", { route });
  };

  const onImageHover = () => {
    setIshover(true)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  };

  const handleCloseWarning = () => {
    setIshover(false);
  };


  return (
    <div className="page__wrapper h-100">
      <Header {...props} />
      <div className="mainContainer CustomerTable">
        <Row noGutters className="h-100">
          <Sidebar {...props} />

          <Col md={9} lg={10} className="boxTyp3">
            <div className="container-fluid">
              <div className="content-wrapper">
                {ishover && routes.some(route => route.status === "Expiring soon") && (
                  <WarningBox
                    statusMessage={formatStatusMessage(
                      routes.find(route => route.status === "Expiring soon")?.statusMessage || "Default message"
                    )}
                    islistPage={true}
                    onClose={handleCloseWarning}

                  />
                )}


                <div className="page-header mb-3">
                  <div>
                    <h3 className="font-weight-normal mb-0 line-ht fs-24 color-33 text-nowrap">
                      List of Routes{" "}
                      <span className="color-grey">({totalRecords})</span>
                    </h3>
                  </div>
                  <div className="page-search d-flex justify-content-between justify-content-lg-end gap-3 w-100">
                    <InputGroup className="search-wrap-classic">
                      <InputGroup.Prepend className="search-inner-wrap">
                        <LocationSearchInput
                          placeholder="Source: Locality, City, State, Country"
                          clearValue={clearSource}
                          location={sourceLocation}
                          setLocation={(loc) => {
                            setSourceLocation(loc);
                          }}
                        />
                        <span className="icon-search"></span>
                        <Link
                          className="icon-close1 pointer"
                          onClick={() => {
                            setClearSource(prev => !prev)
                            setSourceLocation("");
                            setPageno(1)
                            getRoutes("", destinationLocation);
                          }}
                        ></Link>
                      </InputGroup.Prepend>
                      <InputGroup className="search-inner-wrap">
                        <LocationSearchInput
                          placeholder="Destination: Locality, City, State, Country"
                          clearValue={clearDestination}
                          location={destinationLocation}
                          setLocation={(loc) => {
                            setDestinationLocation(loc);
                          }}
                        />
                        <span className="icon-search"></span>
                        <Link
                          className="icon-close1 pointer"
                          onClick={() => {
                            setClearDestination(prev => !prev)
                            setDestinationLocation("");
                            setPageno(1)
                            getRoutes(sourceLocation, "");
                          }}
                        ></Link>
                      </InputGroup>
                      <button
                        className="find-btn"
                        disabled={!(destinationLocation || sourceLocation)}
                        onClick={() => {
                          setPageno(1)
                          getRoutes(sourceLocation, destinationLocation)
                        }}
                      >
                        Find
                      </button>
                    </InputGroup>
                    <div className="d-flex gap-3">
                      <Form>
                        <Form.Group controlId="formBasicEmail" className="mb-0">
                          <Form.Control
                            className="login-input select-rounded text-capitalize"
                            as="select"
                            custom
                            name="roleId"
                            value="LOCAL"
                            disabled
                            onChange={(e) => handleSelectChange(e)}
                          >
                            <option value="Local">Local</option>
                          </Form.Control>
                        </Form.Group>
                      </Form>
                      <button
                        className="button rounded-pill btnPrimary text-nowrap px-4"
                        onClick={() => history.push("/add-route", routes)}
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-12">
                    <Table responsive className="route-table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>
                            Delivery Type{" "}
                            <a
                              href="#"
                              className="icon-up-and-down color-light-grey"
                              onClick={() => handleSortChange("deliveryType")}
                            >
                              {sortBy === "deliveryType" && sortOrder === "asc"
                                ? ""
                                : ""}
                            </a>
                          </th>
                          <th>Source</th>
                          <th>Destination</th>
                          <th>Created by </th>
                          <th>
                            Subscribed{" "}
                            <a
                              href="#"
                              className="icon-up-and-down color-light-grey"
                              onClick={() =>
                                handleSortChange("subscribedCount")
                              }
                            >
                              {sortBy === "subscribedCount" &&
                                sortOrder === "asc"
                                ? ""
                                : ""}
                            </a>
                          </th>
                          <th>Status </th>
                          <th>Active/Inactive </th>
                          <th>Action </th>
                        </tr>
                      </thead>
                      <tbody className="ttl-order-table">
                        {routes.length > 0 ? (
                          routes.map((route, index) => (
                            <tr
                              key={route.id || index}
                              className={route.status === 'Expiring soon' ? 'row-expiring-soon' : ''}
                            >

                              <td>{route.status === 'Expiring soon' && (
                                <img
                                  src={reject}
                                  style={{
                                    width: '16px',
                                    marginRight: '5px',
                                  }}
                                  onMouseOver={() => { onImageHover(route) }}
                                  onClick={handleCloseWarning}
                                  alt="Expiring soon"
                                />
                              )}{(pageno - 1) * records + index + 1}</td>
                              <td>{toTitleCase(route.deliveryType)}</td>
                              <td>{route.source}</td>
                              <td>{route.destination}</td>
                              <td>{route.createdBy}</td>
                              <td>{route.subscribedCount}</td>

                              <td
                                className={getStatusClassName(
                                  route?.status
                                )}
                              >
                                <div className="flex-active">
                                  <span
                                    className="ab-dot"
                                    style={getStatusBackgroundColor(
                                      route?.status
                                    )}
                                  ></span>
                                  {route?.status}
                                </div>
                              </td>

                              <td className="text-center">
                                <Form>
                                  <Form.Check
                                    type="switch"
                                    id={`customSwitch${index}`}
                                    label=""
                                    className="custom-switch-green"
                                    checked={route.active}
                                    onChange={(e) =>
                                      handleSwitchChange(route.routeId, e.target.checked)
                                    }
                                  />
                                </Form>
                              </td>
                              <td className="pointer views-icos">
                                <span onClick={() => handleViewCLick(route)} role="button" tabIndex={0}>
                                  <span title="View" className="icon-eye"></span>
                                   {/* View */}
                                </span>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="9" className="text-center">
                              No routes found
                            </td>
                          </tr>
                        )}
                      </tbody>

                    </Table>
                    {routes.length > 0 && (
                      <nav aria-label="Page navigation">
                        <ul className="pagination pg-blue deliva-pagination justify-content-end">
                          <li className="page-item">
                            <button
                              className="page-link rotate-180 control-btn"
                              aria-label="Previous"
                              onClick={() => onChangePage(pageno - 1)}
                              disabled={pageno === 1}
                            >
                              <span className="icon-next"></span>
                              <span className="sr-only">Previous</span>
                            </button>
                          </li>

                          {pageArray.map((page, ind) => (
                            <li key={ind} className="page-item">
                              <a
                                className={`page-link ${pageno === page ? "active" : ""
                                  }`}
                                onClick={() => onChangePage(page)}
                              >
                                {page}
                              </a>
                            </li>
                          ))}

                          <li className="page-item">
                            <button
                              className="page-link control-btn"
                              aria-label="Next"
                              onClick={() => onChangePage(pageno + 1)}
                              disabled={pageno === totalPage}
                            >
                              <span className="icon-next"></span>
                              <span className="sr-only">Next</span>
                            </button>
                          </li>

                          <li className="page-value">
                            Enter Per Page{" "}
                            <input
                              type="text"
                              placeholder="Records"
                              name="records"
                              value={records}
                              onChange={onChangeItemPerPage}
                            />
                          </li>
                        </ul>
                      </nav>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <Footer {...props} />
          </Col>
        </Row>
      </div>
      <Loader showLoader={loading} />

    </div >
  );
};

export default RouteList;
